import React from "react";

type State = {
  isUserLoaded: boolean;
};

const UserContext = React.createContext({} as State);

export default UserContext;
